import React from "react";
import styled from "styled-components";
import { spacing } from "../theme";
import Label from "./Label";
import Grid, { TopicItem } from "./TopicGrid";
import { format } from "date-fns";
import { ApiResult } from "../../lib/CmsApi";
import Section from "../sections/Section";
import Content from "./Content";
import { AriaDate } from "../../lib/formatters";

interface Props {
  news: ApiResult<"listMagazinNews">;
  leftIndented?: boolean;
}
const StyledLabel = styled(Label)`
  ${spacing("margin-bottom", 48)}
`;
const RelatedNews = (props: Props) => (
  <Section inline as="aside" aria-label="zugehörige Nachrichten">
    <Content padded leftIndented={props.leftIndented}>
      <StyledLabel big as="h2">
        Das könnte Sie auch interessieren
      </StyledLabel>
      <Grid
        columns={props.leftIndented ? 2 : 3}
        mobileColumns={props.leftIndented ? 1 : 2}
        tinyColumns={1}
        columnGap={4 * 12}
      >
        {props.news.items.map(article => (
          <TopicItem
            key={article.slug}
            embeddedStyle
            ghost
            grey
            type={<AriaDate date={article.date} />}
            image={article.headerImage}
            headline={article.title}
            text={article.description}
            cta="Weiterlesen"
            link={{
              route: "newsArticle",
              params: { slug: article.slug }
            }}
          />
        ))}
      </Grid>
    </Content>
  </Section>
);
export default RelatedNews;
